<template>
  <div>
    <div class="d-flex w-100 mb-2">
      <span class="font-weight-bold" style="min-width:40px;">City: </span>
      <div class="flex-fill">
          <div class="d-flex w-100 mb-1" v-for="item in guiasCity" :key="item.id">
            <span class="flex-fill">{{ item.nombre }}</span>
            <div>
              <button class="btn btn-xs btn-icon btn-light-danger" @click="removeGuia(item)" :disabled="item.loading">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <div class="d-flex w-100">
            <div class="flex-fill">
              <select v-model="fd.idGuiaCity" class="w-100" style="height:23px">
                <option v-for="item in guiasPerDay" :key="item.idGuia" :value="item.idGuia">{{ item.guia }}</option>
              </select>
            </div>
            <div>
              <button class="btn btn-xs btn-icon btn-light-success" @click="addGuia(1)" :disabled="loading.addCity">
                <i class="fa fa-fw fa-plus"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="d-flex w-100">
      <span class="font-weight-bold" style="min-width:40px;">Valle: </span>
      <div class="flex-fill">
          <div class="d-flex w-100 mb-1" v-for="item in guiasValle" :key="item.id">
            <span class="flex-fill">{{ item.nombre }}</span>
            <div>
              <button class="btn btn-xs btn-icon btn-light-danger" @click="removeGuia(item)" :disabled="item.loading">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <div class="d-flex w-100">
            <div class="flex-fill">
              <select v-model="fd.idGuiaValle" class="w-100" style="height:23px">
                <option v-for="item in guiasPerDay" :key="item.idGuia" :value="item.idGuia">{{ item.guia }}</option>
              </select>
            </div>
            <div>
              <button class="btn btn-xs btn-icon btn-light-success" @click="addGuia(2)" :disabled="loading.addValle">
                <i class="fa fa-fw fa-plus"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="d-flex w-100 mt-2" v-if="idModule == 2">
      <span class="font-weight-bold" style="min-width:40px;">MaPi: </span>
      <div class="flex-fill">
          <div class="d-flex w-100 mb-1" v-for="item in guiasMaPi" :key="item.id">
            <span class="flex-fill">{{ item.nombre }}</span>
            <div>
              <button class="btn btn-xs btn-icon btn-light-danger" @click="removeGuia(item)" :disabled="item.loading">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <div class="d-flex w-100">
            <div class="flex-fill">
              <select v-model="fd.idGuiaMaPi" class="w-100" style="height:23px">
                <option v-for="item in guiasPerDay" :key="item.idGuia" :value="item.idGuia">{{ item.guia }}</option>
              </select>
            </div>
            <div>
              <button class="btn btn-xs btn-icon btn-light-success" @click="addGuia(3)" :disabled="loading.addMaPi">
                <i class="fa fa-fw fa-plus"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    num: Number,
    guias: Array,
    idModule: Number,
    month: String,
    calendario: Array
  },
  data() {
    return {
      fd: {
        idGuiaCity: null,
        idGuiaValle: null,
        idGuiaMaPi: null,
      },
      loading: {
        addCity: false,
        addValle: false,
        addMaPi: false,
      },
      containers: {
        day: this.$dayjs(`${this.month}-${this.num}`, 'YYYY-MM-D').format('YYYY-MM-DD'),
        guias: this.guias,
        meGuias: []
      }
    }
  },
  created () {
    const vm = this;
    const meGuias = [];
    vm.calendario.forEach(item => {
      if (item.fecha == vm.containers.day) {
        item.guiasNombres.forEach(item2 => {
          meGuias.push({
            ...item2,
            idServicio: item.servicio,
            loading: false
          })
        })
      }
    });

    vm.containers.meGuias = meGuias;
  },
  computed: {
    guiasPerDay () {
      const vm = this;
      return vm.containers.guias.filter(item => item.diasTrabajo.includes(vm.num));
    },
    guiasCity () {
      return this.containers.meGuias.filter(item => item.idServicio == 1);
    },
    guiasValle () {
      return this.containers.meGuias.filter(item => item.idServicio == 2);
    },
    guiasMaPi () {
      return this.containers.meGuias.filter(item => item.idServicio == 3);
    }
  },
  watch: {
    guias: {
      handler (newVal) {
        this.containers.guias = newVal;
      },
      deep: true
    }
  },
  methods: {
    addGuia (pIdServicio) {
      const vm = this;
      const idGuia = vm.getIdGuiaByService(pIdServicio);

      if (!idGuia) {
        return vm.$swal.fire('', 'Selecciona un guía', 'warning');
      }

      if (vm.containers.meGuias.find(item => item.id == idGuia && item.idServicio == pIdServicio)) {
        vm.clearSelect(pIdServicio);
        return;
      }

      vm.setLoading(pIdServicio, true);

      vm.axios.post('/programacion/guias/calendario', {
        idGuia: idGuia,
        idModule: vm.idModule,
        date: vm.containers.day,
        idServicio: pIdServicio,
      })
      .then(response => {
        
        vm.containers.meGuias.push({
          id: idGuia,
          idServicio: pIdServicio,
          nombre: vm.guiasPerDay.find(item => item.idGuia == idGuia).guia,
          loading: false
        })

        vm.clearSelect(pIdServicio);
      })
      .catch(error => {
        vm.$toast.fire('', 'Error al agregar', 'error');
      })
      .finally(() => {
        vm.setLoading(pIdServicio, false);
      });
    },
    removeGuia (pItem) {
      const vm = this;

      pItem.loading = true;

      vm.axios.delete('/programacion/guias/calendario', {
        params: {
          idGuia: pItem.id,
          idModule: vm.idModule,
          date: vm.containers.day,
          idServicio: pItem.idServicio,
        }
      })
      .then(response => {
        vm.containers.meGuias = vm.containers.meGuias.filter(item => {
          return !(item.id == pItem.id && item.idServicio == pItem.idServicio);
        });
      })
      .catch(error => {
        vm.$toast.fire('Error al eliminar', '', 'error');
      })
      .finally(() => {
        pItem.loading = false;
      });
    },
    setLoading (pIdServicio, pState) {
      switch (pIdServicio) {
        case 1:
          return this.loading.addCity = pState;
          break;
        case 2:
          return this.loading.addValle = pState;
          break;
        case 3:
          return this.loading.addMaPi = pState;
          break;
        default:
          break;
      }
    },
    clearSelect(pIdServicio) {
      if (pIdServicio == 1) {
        this.fd.idGuiaCity = null;
      }else if (pIdServicio == 2) {
        this.fd.idGuiaValle = null;
      }else if (pIdServicio == 3) {
        this.fd.idGuiaMaPi = null;
      }
    },
    getIdGuiaByService (pIdServicio) {
      switch (pIdServicio) {
        case 1:
          return this.fd.idGuiaCity;
          break;
        case 2:
          return this.fd.idGuiaValle;
          break;
        case 3:
          return this.fd.idGuiaMaPi;
          break;
        default:
          break;
      }
    }
  }
}
</script>